import UserSvg from 'assets/user.svg'
import { clsx } from 'clsx'
import { IconButton } from 'component/Button/IconButton'
import { Sticker } from 'component/Glass'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import ProfileStore from 'store/profile/ProfileStore'
import { store } from 'store/store'
import css from './ProfileButton.module.scss'

type Props = {
  it: ProfileStore | undefined
}

export const ProfileButton = observer(({ it }: Props) => {
  const active = it && it.identity_id === store.profile.identity_id
  const picture = it?.picture
  const created = store.identities.profiles.reduce((r, it) => r + (it.identity_id ? 1 : 0), 0)
  const className = clsx(css.circle, active && css.selected)
  const canDelete = !!it && created > 1

  const onSelect = useLatestCallback(() => {
    store.identities.open = false
    if (it === undefined) {
      controller.openCreateProfile()
    } else {
      controller.selectProfile(it)
    }
  })

  const onDelete = useLatestCallback(() => {
    if (it) controller.deleteProfile(it)
  })

  function icon() {
    if (picture) return <Image className={css.photo} src={picture} />
    if (it) return <UserSvg className={css.empty} width={24} height={24} />
    return (
      <Space className={css.dash} center>
        <Icon size={24} name="add" />
      </Space>
    )
  }

  return (
    <Space className={css.button} center>
      <Space className={className} onClick={onSelect}>
        <Space className={css.inner} center>
          {icon()}
        </Space>
      </Space>
      <Sticker circle pin={[-12, -12, null, null]}>
        {canDelete && <IconButton size={24} action={onDelete}>
          <Icon size={16} name="delete" />
        </IconButton>}
      </Sticker>
    </Space>
  )
})
